import location from './location';

export default {
  location,
};
